  <template>
  <div id="role-groups">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card" style="padding:0px; box-shadow:unset;">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{this.$t('event.buttons.authGroups')}}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getUserGroups')"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.addNew')" placement="top">
                  <el-button
                    icon="fas fa-plus"
                    size="mini"
                    type="primary"
                    @click="updateForm = null;
                    initAdd();
                modalVisible = true;"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <el-table
            v-loading="$store.state.users.loading"
            ref="multipleTable"
            :data="$store.state.users.groups"
            style="width: 100%"
          >
            <el-table-column :label="$t('event.table.title')" property="title" min-width="200"></el-table-column>

            <el-table-column :label="$t('event.tags.authNo')" width="110">
              <template slot-scope="scope">{{ scope.row.roleNames.length }}</template>
            </el-table-column>

            <el-table-column :label="$t('event.table.userNo')" width="110">
              <template slot-scope="scope">{{ scope.row.userCount }}</template>
            </el-table-column>

            <el-table-column :align="'center'" :label="$t('event.table.processes')" width="150" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      initUpdate(scope.row)
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm
                    @confirm="deleteItem(scope.$index)"
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('event.textbox.toDelete')"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      icon="fas fa-trash"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.table.editAuth')"
      width="60%"
      :append-to-body="true"
    >
      <RoleGroupAddUpdate
        @deleteMe="deleteItem"
        @closeMe="modalVisible = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import RoleGroupAddUpdate from "./RoleGroupAddUpdate";
export default {
  components: { PageCountInfo, RoleGroupAddUpdate },
  name: "RoleGroups",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary"
    };
  },
  methods: {
    initUpdate(row) {
      this.updateForm = JSON.parse(JSON.stringify(row));

      this.$store.state.users.roles.map((group, groupIndex) => {
        this.$store.state.users.roles[groupIndex].selectedRoles = [];
        group.roles.map((groupRole, groupRoleIndex) => {
          if (
            this.updateForm.roleNames.some(
              k => k == group.name + groupRole.name
            )
          ) {
            this.$store.state.users.roles[groupIndex].selectedRoles.push(
              group.name + groupRole.name
            );
          }
        });
      });

      this.modalVisible = true;
    },
    initAdd() {
      this.$store.state.users.roles.map((group, groupIndex) => {
        this.$store.state.users.roles[groupIndex].selectedRoles = [];
      });

      this.modalVisible = true;
    },
    itemUpdated(item) {
      this.$store.dispatch("getUserGroups");
    },
    itemAdded(item) {
      this.$store.dispatch("getUserGroups");
    },
    deleteItem(index) {
      this.$store.dispatch("deleteRole", { index, context: this });
    }
  },
  mounted() {
    this.$store.dispatch("getUserGroups");
    this.$store.dispatch("loadAllRoles");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RoleGroups.vue